module.exports = __webpack_public_path__ + "static/WEDDING E&M-450-ec9717e1a9c47d610fd34f9b873abaaf.jpg";